module.exports = "/images/assistance.jpg?de7f39432e7d909b1c27b5fbac075fc5";